import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CheckPermission } from 'src/app/models/checkPermission';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';

@Directive({
    selector: '[checkPermission]',
    standalone: false
})
export class CheckPermissionDirective {
  
  @Input() set checkPermission(permission: CheckPermission) {
    this.isGranted(permission);
  }

  constructor(
    private readonly viewContainerRef: ViewContainerRef, 
    private readonly templateRef: TemplateRef<any>
  ) {}

  private isGranted(permission: CheckPermission): void {
    const roleData = globalThis.localStorage.getItem(LocalStorageKeyEnum.ROLE);
    
    if (!roleData) {
      this.viewContainerRef.clear();
      return;
    }

    const localStorageRole = JSON.parse(roleData);
    const userRole = localStorageRole.role.toLowerCase();

    const isAdmin = userRole === 'administrator';
    const isViewerMatch = permission.role === 'viewer' && userRole === 'viewer';
    const isEditorMatch = (permission.role === 'editor' || permission.role === 'viewer') && 
                          (userRole === 'editor' || isAdmin);
    const isErpMatch = permission.role === 'erp' && userRole === 'erp';
    const isManagerMatch = (permission.role === 'atlassian_user_manager' || permission.role === 'editor') && 
                           (userRole === 'atlassian_user_manager' || userRole === 'editor');

    if (isAdmin || isViewerMatch || isEditorMatch || isErpMatch || isManagerMatch) {
      this.viewContainerRef.clear(); 
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}